import { jsxs, jsx } from 'react/jsx-runtime';
import { IconDownload, IconTag, IconMove, IconUserPlus } from '@fabric-app/icons/svg';
import { useExpandedFdocContext } from '../../ExpandedFdoc/ExpandedFdocProvider.js';
import { useResourceDataContextSafe } from '../../context/resourceDataContext.js';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';
import { useContextAccessToken } from '../../../../permission/contexts/AnonShareTokenContext.js';
import { useQueryResourceAssets } from '../../../queries/useQueryResourceAssets.js';
import { isResourceDetailNotepad, isResourceNotionNotepad } from '../../../../resources/utils/resourceDetailGuards.js';
import { resourceTagsModal } from '../../../../tags/components/ModalResourceTags/resourceTagsStore.js';
import { resourceSharingModal } from '../../../../permission/components/ModalShare/resourceSharingStore.js';
import { useHandleOpenAssetsPanel } from '../../NotepadAssetsPanel/useOpenAssetsPanel.js';
import { IconResourceKind } from '@fabric-app/icons/mobile';
import { DropdownItemResourceUserPinHome } from '../../DropdownItems/DropdownItemResourceUserPinHome.js';
import { DropdownItemResourceDeleteOrLeave } from '../../DropdownItems/DropdownItemResourceDeleteOrLeave.js';
import { resourceMoveModal } from '../../../../resources/components/ModalMoveResources/moveResourcesStore.js';

const ExpandedResourceDropdownMenu = ({ children }) => {
  const { handleOnDelete } = useExpandedFdocContext();
  const { resource, disabledActions, handleDownload } = useResourceDataContextSafe();
  const accessToken = useContextAccessToken();
  const handleOpenAssetsPanel = useHandleOpenAssetsPanel();
  const queryAssets = useQueryResourceAssets({
    resourceId: resource.id
  }, {
    enabled: !resource.isDraft && isResourceDetailNotepad(resource)
  });
  return /* @__PURE__ */ jsxs(DropdownMenu.Base, {
    renderTriggerElement: ({ onOpenChange }) => /* @__PURE__ */ jsx(DropdownMenu.TriggerButtonThreeDots, {
      onOpenChange
    }),
    children: [
      /* @__PURE__ */ jsxs(DropdownMenu.Group, {
        children: [
          children,
          handleDownload && /* @__PURE__ */ jsx(DropdownMenu.Item, {
            iconElement: /* @__PURE__ */ jsx(IconDownload, {}),
            onSelect: handleDownload,
            children: "Download"
          }),
          !accessToken && /* @__PURE__ */ jsx(DropdownMenu.Item, {
            iconElement: /* @__PURE__ */ jsx(IconTag, {}),
            onClick: () => resourceTagsModal.open({
              resourceId: resource.id
            }),
            children: "Add/edit tags"
          }),
          /* @__PURE__ */ jsx(DropdownMenu.Item, {
            onClick: () => {
              resourceMoveModal.open({
                resources: [
                  resource
                ]
              });
            },
            "data-testid": "fdoc-add-to-space-button",
            tabIndex: 5,
            iconElement: /* @__PURE__ */ jsx(IconMove, {}),
            disabledReason: disabledActions.move,
            children: "Move..."
          }),
          /* @__PURE__ */ jsx(DropdownMenu.Item, {
            iconElement: /* @__PURE__ */ jsx(IconUserPlus, {}),
            onClick: () => resourceSharingModal.open({
              resourceId: resource.id
            }),
            disabledReason: disabledActions.manageSomePermissionRoles,
            tabIndex: 5,
            children: resource.isDirectShared ? "Manage sharing" : "Share"
          }),
          Boolean(queryAssets.data?.count) && /* @__PURE__ */ jsx(DropdownMenu.Item, {
            iconElement: /* @__PURE__ */ jsx(IconResourceKind, {}),
            onClick: () => handleOpenAssetsPanel(true),
            tabIndex: 5,
            children: isResourceNotionNotepad(resource) ? "View sub-pages" : "View embedded items"
          })
        ]
      }),
      /* @__PURE__ */ jsx(DropdownMenu.Group, {
        children: /* @__PURE__ */ jsx(DropdownItemResourceUserPinHome, {})
      }),
      /* @__PURE__ */ jsx(DropdownMenu.Group, {
        children: /* @__PURE__ */ jsx(DropdownItemResourceDeleteOrLeave, {
          onConfirmDelete: handleOnDelete,
          onConfirmLeave: handleOnDelete
        })
      })
    ]
  });
};

export { ExpandedResourceDropdownMenu };
//# sourceMappingURL=ExpandedResourceDropdownMenu.js.map
